export const SERVER_URL = "https://davidcm.me/gasolineras/api";
// export const SERVER_URL = "http://localhost:3869";
